export class MinifiedArgument {

	constructor(
		public name: string,
		public valueType: string,
		public value: string,
	) {}
}